import { Steps } from 'antd'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { RegisterContext } from '../../pages'

const { Step } = Steps

const StepContainer = styled.div`
  /* width: 55%; */
  .step {
    white-space: nowrap;

    .ant-steps-item-title {
      // color: #fff !important;
    }

    .ant-steps-item-icon {
      border: 1px solid #fff;
    }

    &.ant-steps-item.ant-steps-item-wait {
      display: none;
    }

    &.ant-steps-item-active .ant-steps-item-tail::after {
      display: none;
    }
  }

  .ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: #fff !important;
  }

  .ant-steps-vertical > .ant-steps-item:last-child > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: transparent !important;
  }

  .ant-steps-icon {
    color: #187c6a;
  }

  .ant-steps-item-finish {
    .ant-steps-item-icon {
      background-color: #187c6a !important;
    }

    .ant-steps-icon {
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      top: 1px;
    }
  }
`

export const RegisterStep: React.FC = () => {
  const { state } = useContext(RegisterContext)
  return (
    <StepContainer>
      <Steps direction="vertical" size="small" current={state.step}>
        <Step className="step" title="Enter Your Loan Agreement Number" />
        <Step className="step" title="Terms & Conditions Acceptance" />
        <Step className="step" title="One Time Password Verification" />
        <Step className="step" title="Create User Name" />
        <Step className="step" title="Create Your Password" />
        <Step className="step" title="Choose Your Personal Image & Security Phrase" />
      </Steps>
    </StepContainer>
  )
}

const MobileStepContainer = styled.div`
  .step {
    .ant-steps-item-icon {
      border: 1px solid #fff;
    }
  }
  .ant-steps-item-finish {
    .ant-steps-item-icon {
      background-color: #187c6a !important;
    }

    .ant-steps-icon {
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      top: -1px !important;
    }
  }
`

export const MobileRegisterStep: React.FC = () => {
  const { state } = useContext(RegisterContext)
  return (
    <MobileStepContainer>
      <Steps className="mt-5" responsive={false} direction="horizontal" size="small" current={state.step} labelPlacement="horizontal">
        <Step className="step" title="" />
        <Step className="step" title="" />
        <Step className="step" title="" />
        <Step className="step" title="" />
        <Step className="step" title="" />
        <Step className="step" title="" />
      </Steps>
    </MobileStepContainer>
  )
}
